import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../pages/home/page.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('../pages/info/page.vue'),
    meta: { title: '信息发布' }
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('../pages/schedule/page.vue'),
    meta: { title: '赛事规程' }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('../pages/calendar/page.vue'),
    meta: { title: '活动日程' }
  },
  {
    path: '/teams',
    name: 'teams',
    component: () => import('../pages/teams/page.vue'),
    meta: { title: '参赛队伍' }
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../pages/order/page.vue'),
    meta: { title: '比赛实况' }
  },
  {
    path: '/appearance',
    name: 'appearance',
    component: () => import('../pages/appearance/page.vue'),
    meta: { title: '出场顺序' }
  },
  {
    path: '/results',
    name: 'results',
    component: () => import('../pages/results/page.vue'),
    meta: { title: '成绩' }
  },
  {
    path: '/awards',
    name: 'awards',
    component: () => import('../pages/awards/page.vue'),
    meta: { title: '奖牌榜' }
  },
  {
    path: '/livephoto',
    name: 'livephoto',
    component: () => import('../pages/livephoto/page.vue'),
    meta: { title: '图片直播' }
  },
  {
    path: '/404',
    name: 'not-found',
    component: () => import('../pages/NotFound.vue'),
    meta: { title: '页面未找到' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
];

const router = createRouter({
  history: createWebHistory(__BASE_PATH__),
  routes
});

// 全局路由卫士，用于动态设置网页标题和添加EventUID参数
router.beforeEach((to, from, next) => {
  // 从 localStorage 获取赛事名称
  const eventName = localStorage.getItem('eventName');
  
  // 如果有赛事名称，则设置为网页标题
  if (eventName) {
    document.title = eventName;
  }
  
  // 获取 EventUID
  let eventUID = to.query.EventUID || localStorage.getItem('EventUID');
  
  // 检查 EventUID 是否有效（不为空、null、undefined或字符串 'null'/'undefined'）
  const isValidEventUID = eventUID && 
                          eventUID !== 'null' && 
                          eventUID !== 'undefined' && 
                          eventUID.trim() !== '';
  
  // 只有当用户从其他页面导航而来（不是直接访问根URL）且有有效的EventUID时，才自动添加
  // 如果是直接访问URL且没有带EventUID，则不自动添加（让用户选择赛事）
  const isDirectAccess = !from.name; // 直接访问时 from.name 为 undefined
  const shouldAddEventUID = !isDirectAccess && !to.query.EventUID && isValidEventUID;
  
  if (shouldAddEventUID) {
    // 保留其他查询参数
    const query = { ...to.query, EventUID: eventUID };
    // 使用 push 而不是 replace，保持浏览器历史记录完整性
    next({ path: to.path, query });
    return;
  }
  
  // 如果 URL 中有有效的 EventUID，则保存到本地存储
  if (to.query.EventUID && to.query.EventUID !== 'null' && to.query.EventUID !== 'undefined') {
    localStorage.setItem('EventUID', to.query.EventUID);
  }
  
  // 继续导航
  next();
});

export default router;